import {
  DimensionUnits,
  ProductSource,
  ProductStatus,
  TrackInventoryOption,
  WeightUnits,
} from '../../../../shared/enums/enum';
import { NamedResponse } from '../../../../shared/models/response-models/named-response.model';

export class PaginatedProductLiteResponseModel {
  totalCount: number = 0;
  pageNumber: number = 1;
  pageSize: number = 15;
  items: ProductLiteResponseModel[] = [];
}

export class ProductLiteResponseModel {
  id: number = 0;
  name: string = '';
  description: string = '';
  sku: string = '';
  height: number = 0;
  width: number = 0;
  length: number = 0;
  weight: number = 0;
  categoryId: number = 0;
  onHandQuantity: number = 0;
  availableQuantity: number = 0;
  dimensionUnit: DimensionUnits = DimensionUnits.Unknown;
  weightUnit: WeightUnits = WeightUnits.Unknown;
  trackInventoryOption: TrackInventoryOption = TrackInventoryOption.Unknown;
  reOrderPoint: number = 0;
  selectProduct: boolean = false;
  createdAt?: Date = new Date();
  lastUpdatedAt?: Date = new Date();

  // Additional fields
  source?: number;
  isUpdated: boolean = false;
  productImages: ProductImagesResponseModel[] = [];
  inventories: InventoriesResponseModel[] = [];
  category: NamedResponse | null = null;
  department: NamedResponse | null = null;
}

export class ProductResponseModel {
  id: number = 0;
  name: string = '';
  sku: string = '';
  source: ProductSource = ProductSource.Unknown;
  status: ProductStatus = ProductStatus.Unknown;
  reOrderPoint: number = 0;
  trackInventoryOption: TrackInventoryOption = TrackInventoryOption.Unknown; // assuming enum exists
  height: number = 0;
  width: number = 0;
  length: number = 0;
  categoryId: number = 0;
  category: NamedResponse = new NamedResponse();
  department: NamedResponse = new NamedResponse();
  dimensionUnit: DimensionUnits = DimensionUnits.Unknown; // assuming enum exists
  weight: number = 0;
  createdAt?: Date = new Date();
  lastUpdatedAt?: Date = new Date();
  weightUnit: WeightUnits = WeightUnits.Unknown; // assuming enum exists
  isFragile: boolean = false;
  productImages: ProductImagesResponseModel[] = [];
  quantity: number = 0;
  onHandQuantity: number = 0;
  availableQuantity: number = 0;
  orderReservedQuantity: number = 0;
  warehouseLocations: NamedResponse[] = [];
  inventories: InventoriesResponseModel[] = [];
  defaultCost: number = 0;
  defaultSellingPrice: number = 0;
  selectProduct: boolean = false;
  isUpdated: boolean = false;
  selectedSerials: ProductSerialReponseModel[] = [];
  notes: string = '';
  description: string = '';
}

export class ProductImagesResponseModel {
  productId: number = 0;
  isPrimary: boolean = false;
  blobFileId: number = 0;
  url: string = '';
  id: number = 0;
}

export class InventoriesResponseModel {
  name: string = '';
  id: number = 0;
  onHandQuantity: number = 0;
  serials: ProductSerialReponseModel[] = [];
}

export class ProductSerialReponseModel {
  id: number = 0;
  serialNumber: string = '';
  productId: number = 0;
  warehouseId: number = 0;
  isSelected?: boolean = false;
  isProcessing?: boolean = false;
  productionCycleId?: number = 0;
}

export class ProductNamedResponseModel {
  id: number = 0;
  name: string = '';
  sku?: string;
  defaultSellingPrice: number = 0;
  categoryId?: number;
  departmentId?: number;
  category?: NamedResponse;
  department?: NamedResponse;
}
